"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTooltipStyles = void 0;
var _constants = require("../../components/constants");
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _getRgbaFromHex = _interopRequireDefault(require("../../utils/getRgbaFromHex"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var styles = function styles(theme) {
  return {
    tooltip: {
      display: "block",
      opacity: 0,
      zIndex: 0,
      background: (0, _getRgbaFromHex.default)(theme.colors.baseShadow, 0.8),
      color: theme.colors.textOnDark,
      fontSize: theme.typography.fontSize - 2,
      fontFamily: theme.typography.fontFamily,
      padding: "".concat(theme.spacing.base / 2, "px ").concat(theme.spacing.base, "px"),
      lineHeight: "1.4em",
      position: "absolute",
      transition: "opacity 300ms",
      borderRadius: 0,
      textAlign: "center",
      pointerEvents: "none",
      maxWidth: "100vw"
    },
    visible: {
      opacity: 1,
      zIndex: _constants.Z_INDEX.Tooltip
    },
    hidden: {
      display: "none"
    }
  };
};
var useTooltipStyles = exports.useTooltipStyles = (0, _createUseStyles.default)(styles, {
  name: "Tooltip"
});